
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/registration-trademark",
      function () {
        return require("private-next-pages/registration-trademark.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/registration-trademark"])
      });
    }
  